module.exports = __webpack_public_path__ + "img/ask.662abc60.svg";